module.exports = __webpack_public_path__ + "5485224f9a0efed1c9f3d0a457399990.jpg";